/*----------------------------------------------------------------------------*\
    FORM.ELEMENTS.FILE-UNI
    Simple file custom upload API
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};

var uploadUrl = '';
var extentiontype = '';
/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */

/*global plupload */



/*  Component
\*----------------------------------------------------------------------------*/

oy.form.elements.fileUni = {

    init: function (onUploadedCallback, onUploadedCallbackFailed) {
        if (oy.cutsMustard) {
            this.initElements(document, onUploadedCallback, onUploadedCallbackFailed);
        }
    },

    changeUploadUrl(newUrl) {
        uploadUrl = newUrl;
    },

    changeExtentiontype(newExtentiontype) {
        extentiontype = newExtentiontype;
    },

    initElements: function ($context, onUploadedCallback, onUploadedCallbackFailed) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--file-uni');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupElement($element, onUploadedCallback, onUploadedCallbackFailed);
        }
    },

    setupElement: function ($context, onUploadedCallback, onUploadedCallbackFailed) {
        if ($context.classList.contains('is-initialised')) {
            return;
        }
        var $button = $context.querySelector('.js--file-uni__button');
        var $wrap = $context.querySelector('.js--file-uni__wrap');
        var uploader = new plupload.Uploader({
            browse_button: $button, // eslint-disable-line camelcase
            container: $context,
            max_file_size: '50mb', // eslint-disable-line camelcase
            multi_selection: false, // eslint-disable-line camelcase
            url: $context.dataset.pluploadUrl,
            extentiontype: $context.dataset.pluploadExtentiontype,
            filters: [
                { title: 'Image files', extensions: $context.dataset.pluploadExtentiontype }
            ],
            init: {
                FilesAdded: function (up, files) {
                    plupload.each(files, function (file) {
                        if (up.files.length > 1) {
                            up.removeFile(file);
                        }
                    });
                    if (up.files.length >= 1) {
                        $context.classList.add('is-uploading');
                    }
                },
                FilesRemoved: function (up) {
                    if (up.files.length < 1) {
                        $context.classList.remove('is-uploading');
                    }
                }
            },
            multipart: true
        });

        uploader.bind('Init', function () {
            $context.classList.add('is-initialised');
            $button.removeAttribute('disabled');
            $wrap.innerHTML = '';
        });

        uploader.bind('FilesAdded', function (up, files) {
            $context.classList.add('is-uploading');
            for (var i in files) {
                $wrap.innerHTML = '<div class="o-box  o-box__module  t-background--iron-f" id="' + files[i].id + '">Bezig met uploaden:<br>' + files[i].name + ' (' + plupload.formatSize(files[i].size) + ') <strong class="js--file-uni__progress"></strong></div>';
            }
            setTimeout(function () {
                uploader.start();
            }, 250);
        });

        uploader.init();

        uploader.bind('BeforeUpload', function (uploader) {
            if (uploadUrl !== '' && uploadUrl !== uploader.settings.url) {
                uploader.settings.url = uploadUrl;
            }
            if (extentiontype !== '' && extentiontype !== uploader.settings.extentiontype) {
                uploader.settings.extentiontype = extentiontype;
            }
        });

        uploader.bind('UploadProgress', function (up, file) {
            $wrap.querySelector('.js--file-uni__progress').innerHTML = file.percent + '%';
        });

        uploader.bind('FileUploaded', function (up, file, ret) {
            // Parse the response once
            var parsedResponse = JSON.parse(ret.response);
            if (parsedResponse.UploadType === 'excel') {
                if (parsedResponse.Text !== 'OK') {
                    onUploadedCallbackFailed(parsedResponse.Text);
                } else {
                    if (typeof onUploadedCallback !== 'undefined') {
                        onUploadedCallback();
                    }
                }
            }

            // Check if the response is 'ok' or 'true'
            else if (parsedResponse === 'ok' || ret.response === 'true') {
                if (typeof onUploadedCallback !== 'undefined') {
                    onUploadedCallback(parsedResponse);
                }
            } else {
                alert('Er is iets misgegaan bij het uploaden.\nSelecteer alleen JPG of PNG bestanden.');
            }

        });

        uploader.bind('UploadComplete', function (up) {
            $wrap.innerHTML = '';
            $context.classList.remove('is-uploading');
            up.splice();
            up.refresh();
            if ($context.dataset.pluploadRefresh === 'true') {
                window.location.reload();
            }
        });

        uploader.bind('Error', function (up, args) {
            $context.classList.remove('is-uploading');
            alert('Fout! Het bestand is geen foto of te groot.\nSelecteer alleen JPG of PNG bestanden.\n\n' + args.code + ': ' + args.message);
            up.splice();
        });

    }
};



// To trigger the refresh

/**
 * Fire ALL the things
 */
window.addEventListener('load', function (event) {
    // this makes sure the thing isn't triggered from iFrames
    if (event.currentTarget !== null && event.currentTarget.frameElement === null) {
        oy.form.elements.fileUni.init();
    }
}, false);